import classNames from "classnames";
import Lottie from "lottie-react";

const loaders = require(
  `../../../public/animations/loaders/${process.env.NEXT_PUBLIC_CUSTOMER}/loaders.json`,
);

/* VARIANTS
  "Primary" [ LC: Impulse monogram | LGD: White hanger with primary background]
  "SpinnerMiddleGray"
*/

function CustomLoader({ variant = "Primary", className, style = {} }) {
  return (
    <Lottie
      animationData={require(
        `public/animations/loaders/${process.env.NEXT_PUBLIC_CUSTOMER}/${loaders[variant]}`,
      )}
      className={classNames("loader-center", className)}
      style={style}
      autoPlay
      loop
      speed={1.5}
    />
  );
}

export default CustomLoader;
